import React from 'react';
import { useCTA } from './CTAContext';
const CTA_LINK = 'https://wa.me/40756617959?text=Salut.%0A%0ADoresc%20detalii%20despre%20certificarea%20de%20NLP%20Practitioner.%0A%0AMul%C8%9Bumesc.';
interface ButtonProps {
  variant?: 'primary' | 'outline';
  className?: string;
  children: React.ReactNode;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  className = ''
}) => {
  const cta = useCTA();
  const baseStyle = 'inline-flex items-center justify-center px-8 py-4 font-display font-semibold tracking-wide transition-all duration-300 text-sm uppercase';
  const variants = {
    primary: 'bg-gold text-navy-dark hover:bg-white hover:text-navy-dark',
    outline: 'border border-gold text-gold hover:bg-gold hover:text-navy-dark'
  };
  const classes = `${baseStyle} ${variants[variant]} ${className}`;
  const content = cta.label ?? children;
  if (cta.mode === 'scroll') {
    const handleClick = () => {
      const el = document.getElementById(cta.target ?? 'pricing');
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    };
    return <button type="button" onClick={handleClick} className={classes} data-id="element-483">
        {content}
      </button>;
  }
  return <a href={CTA_LINK} className={classes} data-id="element-484">
      {content}
    </a>;
};
export const NeuralBackground = () => <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-[0.15]" data-id="element-485">
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-486">
      <defs data-id="element-487">
        <pattern id="neural" x="0" y="0" width="120" height="120" patternUnits="userSpaceOnUse" data-id="element-488">
          <circle cx="30" cy="30" r="1.5" fill="#C9A84C" data-id="element-489" />
          <circle cx="90" cy="45" r="2" fill="#C9A84C" data-id="element-490" />
          <circle cx="45" cy="90" r="1.5" fill="#C9A84C" data-id="element-491" />
          <circle cx="105" cy="105" r="1" fill="#C9A84C" data-id="element-492" />
          <path d="M30 30 L90 45 L45 90 Z" fill="none" stroke="#C9A84C" strokeWidth="0.5" data-id="element-493" />
          <path d="M90 45 L105 105 L45 90" fill="none" stroke="#C9A84C" strokeWidth="0.5" data-id="element-494" />
          <path d="M-10 60 L30 30" fill="none" stroke="#C9A84C" strokeWidth="0.5" data-id="element-495" />
          <path d="M130 30 L90 45" fill="none" stroke="#C9A84C" strokeWidth="0.5" data-id="element-496" />
        </pattern>
      </defs>
      <rect x="0" y="0" width="100%" height="100%" fill="url(#neural)" data-id="element-497" />
    </svg>
  </div>;
export const SectionDivider = () => <div className="w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" data-id="element-498" />;
export const WHATSAPP_LINK = CTA_LINK;